import type LoanRequestDataService from './loan-request.data-service';
import type {
    ActionResponse,
    Document,
    LoanRequest,
    LoanRequestFormActionResponse,
    LoanRequestItem,
    RedirectionResponse
} from 'typings/portaro.be.types';
import {ngAsync} from 'shared/utils/ng-@decorators';

/**
 * @ngdoc service
 * @name loanRequestService
 * @module portaro.services
 *
 * @description
 * Service for loaning Documents and Exemplars
 */
export default class LoanRequestService {
    public static readonly serviceName = 'loanRequestService';

    /*@ngInject*/
    constructor(private loanRequestDataService: LoanRequestDataService) {
    }

    @ngAsync()
    public async requestLoan(pathWithoutApiPrefix: string, loanRequest: LoanRequest): Promise<ActionResponse> {
        return this.loanRequestDataService.requestLoan(pathWithoutApiPrefix, loanRequest);
    }

    @ngAsync()
    public async requestDocument(document: Document): Promise<LoanRequestFormActionResponse | RedirectionResponse> {
        return this.request([{document}]);
    }

    @ngAsync()
    public async requestDocuments(documents: Document[]): Promise<LoanRequestFormActionResponse | RedirectionResponse> {
        const items = documents.map((document) => ({document}));
        return this.request(items);
    }

    @ngAsync()
    public async requestExemplar(exemplarId: number): Promise<LoanRequestFormActionResponse | RedirectionResponse> {
        return this.request([{exemplar: exemplarId}]);
    }

    @ngAsync()
    public async request(items: LoanRequestItem[]): Promise<LoanRequestFormActionResponse | RedirectionResponse> {
        return this.loanRequestDataService.requestLoanForm(items);
    }
}
